<div class="container login-page">
    <div *ngIf="this.loginMode === loginModes.LOGIN" class="content d-flex flex-column">
        <img class="logo align-self-center pb-3" src="./assets/kinvent_logo_500x500.png" alt="Kinvent Logo"/>
        <h1>Welcome to Kinvent Admin</h1>
        <mat-card class="login-card">
            <mat-progress-bar *ngIf="loadingState === loadingStates.LOADING" class="loading" mode="indeterminate"></mat-progress-bar>
            <form [formGroup]="loginForm" (ngSubmit)="onFormSubmit()">
                <mat-card-content>
                    <mat-form-field class="full-width">
                        <mat-label>Email</mat-label>
                        <input matNativeControl type="email" placeholder="example@k-invent.com" formControlName="email">
                    </mat-form-field>
                    <br/>
                    <mat-form-field class="full-width">
                        <mat-label>Password</mat-label>
                        <input matNativeControl type="password" formControlName="password">
                    </mat-form-field>

                </mat-card-content>
                <mat-card-actions>
                    <button class="full-width" color="primary" mat-raised-button type="submit" [disabled]="loginForm.invalid">
                        Log in
                    </button>
                </mat-card-actions>
            </form>
        </mat-card>
    </div>
    <div class="content d-flex flex-column" *ngIf="this.loginMode === loginModes.TWO_FA">
        <img class="logo align-self-center pb-3" src="./assets/kinvent_logo_500x500.png" alt="Kinvent Logo"/>
        <h1>Welcome to Kinvent Admin</h1>
        <div class="flex-grow-1 mat-h3">
            You are trying to login with an admin account, <b>{{email.value}}</b><br>
            A two factor authentication code has been sent to your email.<br>
            Insert the 6-digits code in order to proceed.
        </div>

        <div class="d-flex justify-content-center align-items-center">
            <div class="outer mt-2 mb-2 flex-grow-1">
                <input [(ngModel)]="twoFaCodeText"
                       placeholder="{{twoFaCodeTextHint}}"
                       [maxlength]="twoFaCodeLength"
                       (ngModelChange)="onTwoFaCodeValueChange($event)">
            </div>
            <button class="flex-grow-0 m-3" color="primary" mat-raised-button type='submit'
                    [disabled]="!canSubmit()"
                    (click)="onTwoFaCodeSubmit()">Submit
            </button>

        </div>

        <div class="d-flex align-items-center mt-5 justify-content-center">
            <div class="me-2 h6"> Time remaining until token expiration</div>
            <app-timer (timerComplete)="onTwoFaCodeTimerComplete()"></app-timer>
            <div *ngIf="showExpiredText" class="ms-lg-3 text-danger h5">Expired</div>
        </div>
        <div class="d-flex align-items-center justify-content-center">
            <button class="flex-grow-1 mt-1" color="primary" mat-raised-button type='submit'
                    [disabled]="this.loadingState === loadingStates.LOADING || !canResend"
                    (click)="onResendTokenPressed()">Resend token
            </button>
        </div>
        <mat-progress-bar *ngIf="loadingState === loadingStates.LOADING" class="loading my-3" mode="indeterminate"></mat-progress-bar>
            <button class="flex-grow-1 mt-5" color="primary" mat-raised-button type='submit'
                    [disabled]="this.loadingState === loadingStates.LOADING"
                    (click)="onBackPressed()">Back
            </button>
    </div>
</div>
